import { Grid } from "@material-ui/core";
import React, { useEffect, useContext } from "react";
import { useForm } from "../../useForm";
import Controls from "../../controls/Controls";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FormsRef } from "../../formsRef";

const initialFValues = {
  id: 0,
  title: "",
  titleENG: "",
  subtitle: "",
  subtitleENG: "",
  buttonLabel: "",
  buttonLabelENG: "",
  link: "",
  image: "",
};

const AboutFrom = (props) => {
  const { upload, showModal, handleClose, pageTitle, carry, images } = props;
  const {
    title,
    titleENG,
    subtitle,
    subtitleENG,
    buttonLabel,
    buttonLabelENG,
    link,
    image,
  } = FormsRef();

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initialFValues);

  const handleInputChangeImage = (e) => {
    const { value } = e.target;
    image.current = value;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    upload({
      id: carry.id,
      title: title.current.value,
      titleENG: titleENG.current.value,
      subtitle: subtitle.current.value,
      subtitleENG: subtitleENG.current.value,
      buttonLabel: buttonLabel.current.value,
      buttonLabelENG: buttonLabelENG.current.value,
      link: link.current.value,
      image: image.current,
    });
  };

  useEffect(() => {
    image.current = carry.image;
  });
  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{pageTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control ref={title} defaultValue={carry.title || ""} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Subtitle</Form.Label>
                <Form.Control
                  ref={subtitle}
                  defaultValue={carry.subtitle || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>ButtonLabel</Form.Label>
                <Form.Control
                  ref={buttonLabel}
                  defaultValue={carry.buttonLabel || ""}
                />
              </Form.Group>
              <Controls.Select
                name="image"
                label="Image"
                values={images}
                onChange={handleInputChangeImage}
                defaultValue={carry.image}
              ></Controls.Select>
            </Grid>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>TitleENG</Form.Label>
                <Form.Control
                  ref={titleENG}
                  defaultValue={carry.titleENG || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>SubtitleENG</Form.Label>
                <Form.Control
                  ref={subtitleENG}
                  defaultValue={carry.subtitleENG || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>ButtonLabelENG</Form.Label>
                <Form.Control
                  ref={buttonLabelENG}
                  defaultValue={carry.buttonLabelENG || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Link</Form.Label>
                <Form.Control ref={link} defaultValue={carry.link || ""} />
              </Form.Group>
            </Grid>
          </Grid>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Bezárás
        </Button>
        <Button variant="primary" onClick={handleSubmit} type="submit">
          Mentés
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutFrom;
